import image from "next/image";
import extractVars from "../../utils/extractVariablesFromTemplates";

export default function TheTeam(props) {

  console.log('TEAM',props)
  const direction = [
    {
      nom: "FABRICE SCHLOSSER",
      status: "Directeur",
      mail: "f.schlosser@canal32.fr",
      photoUrl: "fabriceSchlosser.png",
    },
    {
      nom: "DAMIEN ARDEOIS",
      status: "Rédacteur En Chef Adjoint",
      mail: "d.ardeois@canal32.fr",
      photoUrl: "damienArdeois.png",
    },
  ];
  const administration = [
    {
      nom: "SANDRA DURUPT",
      status: "Responsable Administrative",
      mail: "s.durupt@canal32.fr",
      photoUrl: "sandraDurupt.jpg",
    },
  ];
  const journalistes = [
    {
      nom: "CYRILLE TAVERNEY",
      status: "Journaliste",
      mail: "c.taverney@canal32.fr",
      photoUrl: "cyrilleTaverney.jpg",
    },
    {
      nom: "CHRISTIAN VIEIRA",
      status: "Journaliste",
      mail: "c.vieira@canal32.fr",
      photoUrl: "christianVieira.png",
    },
    {
      nom: "AURÉLIE JUIGNET",
      status: "Journaliste",
      mail: "a.juignet@canal32.fr",
      photoUrl: "aurelieJuignet.png",
    },
    {
      nom: "DAVID MUTEL",
      status: "Journaliste Sportif",
      mail: "d.mutel@canal32.fr",
      photoUrl: "davidMutel.png",
    },
    {
      nom: "PAULINE LHERMITTE",
      status: "Journaliste",
      mail: "p.lhermitte@canal32.fr",
      photoUrl: "paulineLhermitte.png",
    },
  ];

  const commerciales = [
    {
      nom: "VALÉRIE PAYEN",
      status: "Commerciale",
      mail: "v.payen@canal32.fr",
      photoUrl: "valeriePayen.jpg",
    },
    {
      nom: "STÉPHANIE CHEVALIER",
      status: "Commerciale",
      mail: "s.chevalier@canal32.fr",
      photoUrl: "stephanieChevalier.jpg",
    },
  ];

  const techniciens = [
    {
      nom: "FLAVIEN LEGER",
      status: "Directeur Technique",
      mail: "f.leger@canal32.fr",
      photoUrl: "flavienLeger.jpeg",
    },
    {
      nom: "MAXIME DA COSTA",
      status: "Technicien",
      mail: "m.dacosta@canal32.fr",
      photoUrl: "maximeDaCosta.png",
    },
    {
      nom: "VALENTIN DIAS",
      status: "Technicien",
      mail: "v.dias@canal32.fr",
      photoUrl: "valentinDias.png",
    },
    {
      nom: "VICTOR DAGOT",
      status: "Technicien",
      mail: "v.dagot@canal32.fr",
      photoUrl: "victorDagot.png",
    },
  ];

  const consultantsFoot = [
    {
      nom: "SÉBASTIEN DALLET",
      status: "Consultant Football",
      mail: null,
      photoUrl: "sebastienDallet.jpg",
    },
  ];

  const PartContainer = ({ title, data }) => {
    const orderMembers = (a,b) =>{
       return parseInt(a.menuindex) - parseInt(b.menuindex)
    }
    return (
      <>
        <TitlePart>{title}</TitlePart>
        <div className="theTeam-partContainer">
        {data.sort(orderMembers).map((e, i) => {
          return <Card data={e} index={i} key={`${title}-member-${i}`}/>;
        })}
        </div>
      </>
    );
  };
  const TitlePart = ({ children }) => {
    return <h2 className="hardfile-title">{children}</h2>;
  };
  const Card = ({ data, index }) => {
    
    const { pagetitle,tmpls } = data;
    const {email_equipe,image_contact,role} = extractVars(tmpls,'team');
    return (
      <div className={`theTeam-card-container`}>
        {image_contact ? 
          <img src={`${process.env.SOURCE_API}${image_contact}`} alt={`Photo de ${pagetitle}`}/>        
        : 
          <img
            alt="Logo de l'entreprise Canal 32"
            src="/images/logo-canal32.jpeg"
          /> 
        }

        <div className="theTeam-card-container-content">
          <div className='name'>{pagetitle}</div>
          <div className='role'>{role}</div>
          <div className='email'>{email_equipe}</div>
        </div>
      </div>
    );
  };
  return ( 
    <>
      {props.teams.items.map(e =>(
        <PartContainer title={e.team} data={e.members} />

      ))}

    </>
  );
}
